<template>
	<div class="withdraw-page">
			 <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane label="文字版" name="first"></el-tab-pane>
				<el-tab-pane label="图形版" name="second"></el-tab-pane>
  			</el-tabs>
			<div v-if="activeName=='first'" class="allstyle">
				<!-- 产品类统计表格 -->
				<el-table
						:data="dataList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
						style="width:50%"
				>
					<el-table-column label="产品类统计" prop="label" header-align="center" align="center"  width="120"></el-table-column>
					<el-table-column label="数量" prop="count" header-align="center" align="center" width=""></el-table-column>
					<el-table-column label="观看数量" prop="watchCount" header-align="center" align="center" width="" ></el-table-column>
					<el-table-column label="已发布" prop="published" header-align="center" align="center" width="" ></el-table-column>
					<el-table-column label="未发布" prop="unpublished" header-align="center" align="center" width="" ></el-table-column>
					<el-table-column label="维护中" prop="maintaining" header-align="center" align="center" width="" ></el-table-column>
					<el-table-column label="已下架" prop="offline" header-align="center" align="center" width="" ></el-table-column>
				</el-table>
				<div style="display:flex;margin-top:20px;">
					<!-- 价格统计表格 -->
					<el-table
							:data="dataList2"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;"
							
					>
				
						<el-table-column label="价格统计" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="价格" prop="price" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="活动后价格" prop="activityPrice" header-align="center" align="center" width=""></el-table-column>
					</el-table>
					<!-- 销售统计表格 -->
					<el-table
							:data="dataList3"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;margin-left:10px;align-self: flex-start;"
					>
						<el-table-column label="销售统计" prop="label" header-align="center" align="center" width="120" ></el-table-column>
						<el-table-column label="数量(个)" prop="count" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="金额(元)" prop="price" header-align="center" align="center" width="" ></el-table-column>
					</el-table>
				</div>
				<div style="display:flex;margin-top:20px;">
					<!-- 提现统计表格 -->
					<el-table
							:data="dataList4"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;"
					>
						<el-table-column label="提现统计" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="订单金额" prop="orderMoney" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="提现到账金额(元)" prop="withdrawMoney" header-align="center" align="center" width="" ></el-table-column>
						<el-table-column label="扣税金额" prop="taxMoney" header-align="center" align="center" width="" ></el-table-column>
						<el-table-column label="当前税率" prop="taxRate" header-align="center" align="center" width="" ></el-table-column>
						<el-table-column label="实际计算税率" prop="taxRateReal" header-align="center" align="center" width="" ></el-table-column>
					</el-table>
					<!-- 合作大V统计表格 -->
					<el-table
							:data="dataList5"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;margin-left:10px;"
					>
						<el-table-column label="合作大V统计" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="数量" prop="bigVCount" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="拉新人数" prop="bigVNewPeopleCount" header-align="center" align="center" width="" ></el-table-column>
						<el-table-column label="拉动消费(元)" prop="bigVConsumeMoney" header-align="center" align="center" width="" ></el-table-column>
					</el-table>
				</div>
				<div style="display:flex;margin-top:20px;">
					<!-- 区域营销统计表格 -->
					<el-table
							:data="dataList6"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;align-self: flex-start;"
					>
						<el-table-column label="区域营销" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="数量" prop="count" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="金额(元)" prop="price" header-align="center" align="center" width="" ></el-table-column>
					</el-table>
					<!-- 学习进度统计表格 -->
					<el-table
							:data="dataList7"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;margin-left:10px;"
					>
						<el-table-column label="学习进度" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="人数" prop="count" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="比例" prop="percent" header-align="center" align="center" width="" ></el-table-column>
					</el-table>
				</div>

				<div style="display:flex;margin-top:20px;">
					<!-- 功能应用类统计1表格 -->
					<el-table
							:data="dataList8"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;"
					>
						<el-table-column label="功能应用类统计1" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="指标" prop="count" header-align="center" align="center" width="">
							<template #default="scope" >
								{{scope.row.count}}
								<span v-if="scope.row.label=='总观看时长' || scope.row.label=='人均观看时长'">分钟</span>
								<span v-else-if="scope.row.label=='总答题数' || scope.row.label=='人均答题数'">题</span>
								<span v-else-if="scope.row.label=='总下载资料次数' || scope.row.label=='人均下载资料次数'">次</span>
								<span v-else>个</span>
							</template>
						</el-table-column>
					</el-table>
					<!-- 功能应用类统计2表格 -->
					<el-table
							:data="dataList9"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;margin-left:10px;align-self: flex-start;"
					>
						<el-table-column label="功能应用类统计2" prop="label" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="指标" prop="count" header-align="center" align="center" width=""></el-table-column>
					</el-table>
				</div>
				<div style="display:flex;margin-top:20px;">
					<el-table
							:data="dataList10"
							border
							stripe
							header-align="center"
							align="center"
							size="medium"
							style="width:50%;"
					>
						<el-table-column label="促销活动名称" prop="name" header-align="center" align="center" width="120"></el-table-column>
						<el-table-column label="参与数量" prop="productCount" header-align="center" align="center" width="">、
							<template #default="scope">
								<span>{{scope.row.productCount}}/{{scope.row.totalCount}}</span>
							</template>
						</el-table-column>
						<el-table-column label="促销类型" prop="discountType" header-align="center" align="center" width="">
							<template #default = "scope">
								<span v-if="scope.row.discountType==1">折扣</span>
								<span v-if="scope.row.discountType==2">优惠券</span>
								<span v-if="scope.row.discountType==3">满减</span>
							</template>
						</el-table-column>
						<el-table-column label="促销规则" prop="discountDescription" header-align="center" align="center" width="">
								<template #default = "scope">
								<span v-if="scope.row.discountType==1">{{scope.row.discountRatio*100}}%</span>
								<span v-if="scope.row.discountType==3">满{{scope.row.discountBasic}}减{{scope.row.discountValue}}</span>
							</template>
						</el-table-column>
						<el-table-column label="活动开始时间" prop="startTime" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="活动结束时间" prop="endTime" header-align="center" align="center" width=""></el-table-column>
						<el-table-column label="是否启用" prop="isEnable" header-align="center" align="center" width="">
							<template #default = "scope">
								<span v-if="scope.row.isEnable==0">未启用</span>
								<span v-if="scope.row.isEnable==1">启用</span>
							</template>
						</el-table-column>


					</el-table>
				</div>
			</div>	
			<div v-if="activeName=='second'">
				<div class="chart-container">
					<!-- 产品类统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">产品类统计</h3>
						<div ref="productChart" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 价格统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">价格统计对比</h3>
						<div ref="priceChart" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 销售统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">销售统计分析</h3>
						<div ref="salesChart" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 提现统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">提现统计详情</h3>
						<div ref="withdrawalChart" style="width: 100%; height: 350px;"></div>
					</div>

					<!-- 合作大V统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">合作大V统计</h3>
						<div ref="bigVChart" style="width: 100%; height: 350px;"></div>
					</div>

					<!-- 区域营销统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">区域营销统计</h3>
						<div ref="regionMarketingChart" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 学习进度统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">学习进度分布</h3>
						<div ref="studyProgressChart" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 功能应用类统计1图表 -->
					<div class="chart-item">
						<h3 class="chart-title">功能应用类统计1</h3>
						<div ref="functionChart1" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 功能应用类统计2图表 -->
					<div class="chart-item">
						<h3 class="chart-title">功能应用类统计2</h3>
						<div ref="functionChart2" style="width: 100%; height: 400px;"></div>
					</div>

					<!-- 促销活动统计图表 -->
					<div class="chart-item">
						<h3 class="chart-title">促销活动统计</h3>
						<div ref="promotionChart" style="width: 100%; height: 400px;"></div>
					</div>
				</div>
			</div>		
	</div>
</template>

<script>
import { getHomeProductCount,getHomePriceAndSalesCount,getHomeCommissionAndBigVAndPromotionCount,getHomeVideoAndPeopleAndClickCount,getHomeOrderDiscountsCount } from "../../api/api";
import * as echarts from 'echarts';

export default {
	data() {
		return {
			activeName:'first',
			dataList: [],
			dataList2:[],
			dataList3:[],
			dataList4:[],
			dataList5:[],
			dataList6:[],
			dataList7:[],
			dataList8:[],
			dataList9:[],
			dataList10:[],
			charts: {} // 存储所有图表实例
		};
	},
	
	
	methods: {
		handleClick(e){
			console.log('e',e.label);
			if(e.label=='图形版'){
				this.activeName = 'second'
				// 切换到图形版时,延迟渲染图表确保DOM已准备好
				this.$nextTick(() => {
					setTimeout(() => {
						this.renderAllCharts();
					}, 100);
				});
			}else{
				this.activeName = 'first'
			}
		},
		 getList() {
			 getHomeProductCount().then(res=>{
				if (res.data.success) {
					const d = res.data?.response
					console.log('res.data',res.data)
					this.dataList = [
						{
							label: '产品总数',
							count: d?.productCount,
							watchCount: d?.productWatchCount,
							published: d?.yiFaBuCount,
							unpublished: d?.weiFaBuCount,
							maintaining: d?.weiHuCount,
							offline: d?.xiaJiaCount
						},
						{
							label: '单品数量',
							count: d?.productOneCount,
							watchCount: d?.productOneWatchCount,
							published: d?.yiFaBuOneCount,
							unpublished: d?.weiFaBuOneCount,
							maintaining: d?.weiHuOneCount,
							offline: d?.xiaJiaOneCount
						},
						{
							label: '合集数量',
							count: d?.productCompilationsCount,
							watchCount: d?.productCompilationsWatchCount,
							published: d?.yiFaBuCompilationsCount,
							unpublished: d?.weiFaBuCompilationsCount,
							maintaining: d?.weiHuCompilationsCount,
							offline: d?.xiaJiaCompilationsCount
						},
						{
							label: '相关资料数量',
							count: d?.productDataCount,
							watchCount: d?.productDataWatchCount,
							published: d?.yiFaBuDataCount,
							unpublished: '-',
							maintaining: '-',
							offline: '-'
						}
  					];
					// 渲染产品类统计图表
					this.$nextTick(() => {
						this.renderProductChart();
					});
				} else {
					this.$message.error(res.data.message);
				}
				
			 })
				
		},
		getList2() {
			 getHomePriceAndSalesCount().then(res=>{
				if (res.data.success) {
					const d = res.data?.response;
					this.dataList2 = [
						{
							label: '单品最高价',
							price: d?.productOneMaxPrice,
							activityPrice: d?.productOneMaxPriceAfter,
							
						},
						{
							label: '单品最低价',
							price: d?.productOneMinPrice,
							activityPrice: d?.productOneMinPriceAfter,
						},
						{
							label: '单品平均价',
							price: d?.productOneAvgPrice,
							activityPrice: d?.productOneAvgPriceAfter
						},
						{
							label: '合集最高价',
							price: d?.productCompilationsMaxPrice,
							activityPrice: d?.productCompilationsMaxPriceAfter
						},{
							label: '合集最低价',
							price: d?.productCompilationsMinPrice,
							activityPrice: d?.productCompilationsMinPriceAfter
						},
						{
							label: '合集平均价',
							price: d?.productCompilationsAvgPrice,
							activityPrice: d?.productCompilationsAvgPriceAfter
						}
  					];

					this.dataList3 =  [
						{
							label: '订单总数',
							count: d?.orderCount,
							price: d?.orderAmountCount,
							
						},
						{
							label: '单品销量',
							count: d?.productOneSalesCount,
							price: d?.productOneSalesAmountCount,
						},
						{
							label: '合集销量',
							count: d?.productCompilationsSalesCount,
							price: d?.productCompilationsSalesAmountCount
						},
						{
							label: '微信支付订单',
							count: d?.wxPayOrderCount,
							price: d?.wxPayOrderAmountCount
						},{
							label: '积分兑换订单',
							count: d?.integralPayOrderCount,
							price: d?.integralPayOrderAmountCount
						}
  					];
					// 渲染价格和 sales 图表
					this.$nextTick(() => {
						this.renderPriceChart();
						this.renderSalesChart();
					});
				} else {
					this.$message.error(res.data.message);
				}
				
			 })
				
		},
		getList3() {
			 getHomeCommissionAndBigVAndPromotionCount().then(res=>{
				if (res.data.success) {
					const d = res.data?.response;
					this.dataList4 = [
						{
							label: '提现金额',
							orderMoney: d?.orderMoney,
							withdrawMoney: d?.withdrawMoney,
							taxMoney:d?.taxMoney,
							taxRate:d?.taxRate,
							taxRateReal:d?.taxRateReal
						}
  					];
					this.dataList5 = [
						{
							label: '大V数量',
							bigVCount: d?.bigVCount,
							bigVNewPeopleCount: d?.bigVNewPeopleCount,
							bigVConsumeMoney:d?.bigVConsumeMoney,
						}
  					];
					this.dataList6 = [
						{
							label: '总量',
							count: d?.regionMarketingCount,
							price: d?.regionMarketingMoney,
						},
						{
							label: '进行中',
							count: d?.regionMarketingDoingCount,
							price: d?.regionMarketingDoingMoney,
						
						},
						{
							label: '未启用',
							count: d?.regionMarketingNotStartCount,
							price: d?.regionMarketingNotStartMoney,
							
						},
						{
							label: '已结束',
							count: d?.regionMarketingEndCount,
							price: d?.regionMarketingEndMoney
						}
  					];
					// 渲染提现、大V和区域营销图表
					this.$nextTick(() => {
						this.renderWithdrawalChart();
						this.renderBigVChart();
						this.renderRegionMarketingChart();
					});
				} else {
					this.$message.error(res.data.message);
				}
				
			 })
				
		},
		getList4() {
			 getHomeVideoAndPeopleAndClickCount().then(res=>{
				if (res.data.success) {
					const d = res.data?.response;
					this.dataList7 = [
						{
							label: '少于25%',
							count: d?.studyLess25,
							percent: d?.studyLess25Percent
						},
						{
							label: '25%——50%',
							count: d?.study25To50,
							percent: d?.study25To50Percent
						},
						{
							label: '51%——75%',
							count: d?.study50To75,
							percent: d?.study50To75Percent
						},
						{
							label: '75%——99%',
							count: d?.study75To99,
							percent: d?.study75To99Percent
						},
						{
							label: '100%',
							count: d?.study100,
							percent: d?.study100Percent
						}
  					];
					this.dataList8 = [
						{
							label: '总观看时长',
							count: d?.totalWatchTime,
						},
						{
							label: '人均观看时长',
							count: d?.avgWatchTime,
						},
						{
							label: '总观看视频数量',
							count: d?.totalWatchVideoNum,
						},
						{
							label: '人均观看数量',
							count: d?.avgWatchVideoNum,
						},
						{
							label: '人均完播数量',
							count: d?.avgFinishNum,
						},
						{
							label: '总答题数',
							count: d?.totalAnswerNum,
						},
						{
							label: '人均答题数',
							count: d?.avgAnswerNum,
						},{
							label: '总下载资料次数',
							count: d?.totalDownloadNum,
						},
						{
							label: '人均下载资料次数',
							count: d?.avgDownloadNum,
						}
  					];

					this.dataList9 = [
						{
							label: '总点赞量',
							count: d?.totalLikeNum,
						},
						{
							label: '人均点赞量',
							count: d?.avgLikeNum,
						},
						{
							label: '总收藏量',
							count: d?.totalCollectNum,
						},
						{
							label: '人均收藏量',
							count: d?.avgCollectNum,
						},
						{
							label: '总分享量',
							count: d?.totalShareNum,
						},
						{
							label: '人均分享量',
							count: d?.avgShareNum,
						}

  					];
					// 渲染学习进度和功能应用图表
					this.$nextTick(() => {
						this.renderStudyProgressChart();
						this.renderFunctionChart1();
						this.renderFunctionChart2();
					});
				} else {
					this.$message.error(res.data.message);
				}
				
			 })
				
		},
		getList5() {
			 getHomeOrderDiscountsCount().then(res=>{
				if (res.data.success) {
					const d = res.data?.response;
					this.dataList10 = d;
					// 渲染促销活动图表
					this.$nextTick(() => {
						this.renderPromotionChart();
					});
				} else {
					this.$message.error(res.data.message);
				}
				
			 })
				
		},
		// 渲染产品类统计图表
		renderProductChart() {
			if (!this.$refs.productChart) return;
			const chart = echarts.init(this.$refs.productChart);
			this.charts.productChart = chart;
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				legend: {
					data: ['数量', '观看数量', '已发布', '未发布', '维护中', '已下架'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.dataList.map(item => item.label)
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: '数量',
						type: 'bar',
						data: this.dataList.map(item => item.count || 0)
					},
					{
						name: '观看数量',
						type: 'bar',
						data: this.dataList.map(item => item.watchCount || 0)
					},
					{
						name: '已发布',
						type: 'bar',
						data: this.dataList.map(item => typeof item.published === 'number' ? item.published : 0)
					},
					{
						name: '未发布',
						type: 'bar',
						data: this.dataList.map(item => typeof item.unpublished === 'number' ? item.unpublished : 0)
					},
					{
						name: '维护中',
						type: 'bar',
						data: this.dataList.map(item => typeof item.maintaining === 'number' ? item.maintaining : 0)
					},
					{
						name: '已下架',
						type: 'bar',
						data: this.dataList.map(item => typeof item.offline === 'number' ? item.offline : 0)
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染价格统计图表
		renderPriceChart() {
			if (!this.$refs.priceChart) return;
			const chart = echarts.init(this.$refs.priceChart);
			this.charts.priceChart = chart;
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				legend: {
					data: ['价格', '活动后价格'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.dataList2.map(item => item.label)
				},
				yAxis: {
					type: 'value',
					name: '价格(元)'
				},
				series: [
					{
						name: '价格',
						type: 'bar',
						data: this.dataList2.map(item => item.price || 0),
						itemStyle: { color: '#5470c6' }
					},
					{
						name: '活动后价格',
						type: 'bar',
						data: this.dataList2.map(item => item.activityPrice || 0),
						itemStyle: { color: '#91cc75' }
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染销售统计图表
		renderSalesChart() {
			if (!this.$refs.salesChart) return;
			const chart = echarts.init(this.$refs.salesChart);
			this.charts.salesChart = chart;
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				legend: {
					data: ['数量', '金额'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.dataList3.map(item => item.label)
				},
				yAxis: [
					{
						type: 'value',
						name: '数量(个)',
						position: 'left'
					},
					{
						type: 'value',
						name: '金额(元)',
						position: 'right'
					}
				],
				series: [
					{
						name: '数量',
						type: 'bar',
						yAxisIndex: 0,
						data: this.dataList3.map(item => item.count || 0)
					},
					{
						name: '金额',
						type: 'line',
						yAxisIndex: 1,
						data: this.dataList3.map(item => item.price || 0),
						itemStyle: { color: '#fac858' }
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染提现统计图表
		renderWithdrawalChart() {
			if (!this.$refs.withdrawalChart) return;
			const chart = echarts.init(this.$refs.withdrawalChart);
			this.charts.withdrawalChart = chart;
			
			const data = this.dataList4[0] || {};
			const option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b}: ¥{c}'
				},
				series: [
					{
						name: '提现统计',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: true,
							formatter: '{b}: ¥{c}'
						},
						data: [
							{ value: data.orderMoney || 0, name: '订单金额' },
							{ value: data.withdrawMoney || 0, name: '提现到账金额' },
							{ value: data.taxMoney || 0, name: '扣税金额' }
						]
					}
				]
			};
			
			chart.setOption(option);
		},
		// 渲染合作大V统计图表
		renderBigVChart() {
			if (!this.$refs.bigVChart) return;
			const chart = echarts.init(this.$refs.bigVChart);
			this.charts.bigVChart = chart;
			
			const data = this.dataList5[0] || {};
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				legend: {
					data: ['数量', '拉新人数', '拉动消费'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['合作大V统计']
				},
				yAxis: {
					type: 'value',
					name: '数值'
				},
				series: [
					{
						name: '数量',
						type: 'bar',
						data: [data.bigVCount || 0],
						itemStyle: { color: '#5470c6' }
					},
					{
						name: '拉新人数',
						type: 'bar',
						data: [data.bigVNewPeopleCount || 0],
						itemStyle: { color: '#91cc75' }
					},
					{
						name: '拉动消费',
						type: 'bar',
						data: [data.bigVConsumeMoney || 0],
						itemStyle: { color: '#fac858' }
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染区域营销统计图表
		renderRegionMarketingChart() {
			if (!this.$refs.regionMarketingChart) return;
			const chart = echarts.init(this.$refs.regionMarketingChart);
			this.charts.regionMarketingChart = chart;
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				legend: {
					data: ['数量', '金额'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.dataList6.map(item => item.label)
				},
				yAxis: [
					{
						type: 'value',
						name: '数量',
						position: 'left'
					},
					{
						type: 'value',
						name: '金额(元)',
						position: 'right'
					}
				],
				series: [
					{
						name: '数量',
						type: 'bar',
						yAxisIndex: 0,
						data: this.dataList6.map(item => item.count || 0)
					},
					{
						name: '金额',
						type: 'line',
						yAxisIndex: 1,
						data: this.dataList6.map(item => item.price || 0),
						itemStyle: { color: '#ee6666' }
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染学习进度统计图表
		renderStudyProgressChart() {
			if (!this.$refs.studyProgressChart) return;
			const chart = echarts.init(this.$refs.studyProgressChart);
			this.charts.studyProgressChart = chart;
			
			const option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b}: {c}人 ({d}%)'
				},
				legend: {
					orient: 'vertical',
					left: 'left',
					top: 'middle'
				},
				series: [
					{
						name: '学习进度',
						type: 'pie',
						radius: '60%',
						data: this.dataList7.map((item, index) => ({
							value: item.count || 0,
							name: item.label,
							itemStyle: {
								color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'][index]
							}
						})),
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染功能应用类统计1图表
		renderFunctionChart1() {
			if (!this.$refs.functionChart1) return;
			const chart = echarts.init(this.$refs.functionChart1);
			this.charts.functionChart1 = chart;
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' }
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: this.dataList8.map(item => item.label),
					axisLabel: {
						rotate: 30,
						interval: 0
					}
				},
				yAxis: {
					type: 'value',
					name: '指标值'
				},
				series: [
					{
						name: '指标',
						type: 'bar',
						data: this.dataList8.map(item => item.count || 0),
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 0.5, color: '#188df0' },
								{ offset: 1, color: '#188df0' }
							])
						}
					}
				]
			};
			chart.setOption(option);
		},
		// 渲染功能应用类统计2图表
		renderFunctionChart2() {
			if (!this.$refs.functionChart2) return;
			// 销毁旧实例，防止多次渲染叠加
			if (this.charts?.functionChart2) {
				this.charts.functionChart2.dispose();
			}
			const chart = echarts.init(this.$refs.functionChart2);
			this.charts.functionChart2 = chart;
			
			const list = this.dataList9 || [];
			if (list.length === 0) {
				chart.clear();
				return;
			}
			
			const colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272'];
			
			// 饼图数据格式化
			const pieData = list.map((item, index) => ({
				name: item.label,
				value: item.count || 0,
				itemStyle: {
					color: colors[index % colors.length]
				}
			}));
			
			const option = {
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(0,0,0,0.65)',
					textStyle: { color: '#fff' },
					padding: [8, 12],
					formatter: params => `
                <span style="display:inline-block;width:10px;height:10px;background:${params.color};margin-right:8px"></span>
                ${params.name}：${params.value}（${params.percent}%）
            `
				},
				grid: { left: 10, right: 10, top: 60, bottom: 50 },
				legend: {
					type: 'scroll',
					orient: 'horizontal',
					bottom: 10,
					left: 'center',
					textStyle: {
						fontSize: 11
					}
				},
				series: [
					{
						type: 'pie',
						radius: ['40%', '70%'], // 环形饼图，改成单扇形去掉数组 radius: '60%'
						center: ['50%', '40%'],
						avoidLabelOverlap: true,
						itemStyle: {
							borderRadius: 4,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 14,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: pieData
					}
				]
			};
			
			chart.setOption(option);
			
			// 窗口自适应
			const resizeHandler = () => chart.resize();
			window.removeEventListener('resize', resizeHandler);
			window.addEventListener('resize', resizeHandler);
		},
		// 渲染促销活动统计图表
		renderPromotionChart() {
			if (!this.$refs.promotionChart || !this.dataList10.length) return;
			const chart = echarts.init(this.$refs.promotionChart);
			this.charts.promotionChart = chart;
			
			const typeMap = { 1: '折扣', 2: '优惠券', 3: '满减' };
			const colorMap = { 1: '#5470c6', 2: '#91cc75', 3: '#fac858' };
			
			// 准备图表数据
			const chartData = this.dataList10.map(item => ({
				name: item.name,
				value: item.productCount,
				total: item.totalCount,
				type: typeMap[item.discountType] || '未知',
				typeCode: item.discountType,
				rule: item.discountType==1?item.discountRatio*100+'%':item.discountType==3?"满"+item.discountBasic+"减"+item.discountValue:'无',
				startTime:item.startTime,
				endTime:item.endTime,
				isEnable:item.isEnable==1?'启用':'未启用'
			}));
			
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: { type: 'shadow' },
					formatter: params => {
						const data = params[0].data;
						return `
							<div style="text-align:left">
								<h4 style="margin:5px 0">${data.name}</h4>
								<p>参与数量: ${data.value}/${data.total}</p>
								<p>促销类型: ${data.type}</p>
								<p>促销规则: ${data.rule}</p>
								<p>开始时间: ${data.startTime}</p>
								<p>结束时间: ${data.endTime}</p>
								<p>是否启用: ${data.isEnable}</p>
							</div>
						`;
					}
				},
				legend: {
					data: Object.values(typeMap),
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: chartData.map(item => item.name),
					axisLabel: {
						rotate: 30,
						interval: 0,
						truncate: {
							maxWidth: 100,
							ellipsis: '...'
						}
					}
				},
				yAxis: {
					type: 'value',
					name: '参与数量'
				},
				series: [
					{
						name: '促销活动',
						type: 'bar',
						data: chartData,
						itemStyle: {
							color: params => colorMap[params.data.typeCode] || '#ccc'
						},
						label: {
							show: true,
							position: 'top',
							formatter: params => `${params.data.value}/${params.data.total}`
						}
					}
				]
			};
			chart.setOption(option);
		},
		// 销毁所有图表实例
		destroyCharts() {
			Object.values(this.charts).forEach(chart => {
				if (chart && !chart.isDisposed()) {
					chart.dispose();
				}
			});
			this.charts = {};
		},
		// 渲染所有图表
		renderAllCharts() {
			// 只有当数据存在时才渲染
			if (this.dataList.length > 0) {
				this.renderProductChart();
			}
			if (this.dataList2.length > 0) {
				this.renderPriceChart();
			}
			if (this.dataList3.length > 0) {
				this.renderSalesChart();
			}
			if (this.dataList4.length > 0) {
				this.renderWithdrawalChart();
			}
			if (this.dataList5.length > 0) {
				this.renderBigVChart();
			}
			if (this.dataList6.length > 0) {
				this.renderRegionMarketingChart();
			}
			if (this.dataList7.length > 0) {
				this.renderStudyProgressChart();
			}
			if (this.dataList8.length > 0) {
				this.renderFunctionChart1();
			}
			if (this.dataList9.length > 0) {
				this.renderFunctionChart2();
			}
			if (this.dataList10 && this.dataList10.length > 0) {
				this.renderPromotionChart();
			}
		}


		
	},
	mounted() {
		this.getList()
		this.getList2()
		this.getList3()
		this.getList4()
		this.getList5()
	},
	beforeDestroy() {
		// 组件销毁时销毁所有图表实例
		this.destroyCharts();
	}
};
</script>

<style scoped>
.withdraw-page {
	width: 100%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}
.chart-container {
	width: 100%;
}
.chart-item {
	margin-bottom: 30px;
	padding: 20px;
	background: #f5f7fa;
	border-radius: 8px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.chart-title {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 20px;
	color: #303133;
	text-align: center;
}
.allstyle{
	padding: 10px;
    background: #f0f2f5;
    border-radius: 8px;
}
</style>